export default "__VITE_ASSET__e6addaa8__"